// extracted by mini-css-extract-plugin
export default {"SuryaPrimary":"#004f71","SuryaSecondry":"#00afa9","SuryaThird":"rgba(0,175,169,.07)"};